var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.logged())?[_c('component-header'),_c('router-view')]:[_c('component-login')],_c('component-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }